import React, {Component} from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Button, Modal as ReactstrapModal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

import { fetchBSDOrder } from '../../state/services/extraService';

class BSDOrderModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            orderId: null,
            bookingId: null,
            errorMessage: null,
            bsdBookingId: null,
        };
    }

    static propTypes = {
        isOpen: PropTypes.bool,
        toggleModal: PropTypes.func,
        fetchBSDOrder: PropTypes.func.isRequired,
        extraErrorMessage: PropTypes.string,
        isFetchingBSDOrder: PropTypes.bool,
        bsdBookingId: PropTypes.number,
        history: PropTypes.object.isRequired,
    };

    static defaultProps = {
        isOpen: false,
        extraErrorMessage: '',
        isFetchingBSDOrder: false,
        bsdBookingId: null,
    };

    UNSAFE_componentWillReceiveProps(newProps) {
        if (newProps.bsdBookingId && newProps.bsdBookingId !== this.props.bsdBookingId) {
            this.setState({bsdBookingId: newProps.bsdBookingId});
        }

        if (newProps.extraErrorMessage && newProps.extraErrorMessage.indexOf('Order already exist') !== -1) {
            const index = newProps.extraErrorMessage.indexOf('Booking Id:');
            this.setState({bsdBookingId: newProps.extraErrorMessage.substring(index + 12)});
        }
    }

    handleInputChange(e) {
        const orderNumber = e.target.value;
        this.setState({orderNumber, errorMessage: null});
    }

    onClickFetch() {
        const {orderNumber} = this.state;

        if (!orderNumber) {
            this.setState({errorMessage: 'Order Number is required.'});
            return;
        }

        this.props.fetchBSDOrder(orderNumber);
    }

    onClickGotoBooking() {
        const {bsdBookingId} = this.state;
        window.location.href = '/booking?bookingId=' + bsdBookingId;
    }
    
    render() {
        const {orderNumber, bsdBookingId} = this.state;
        const {extraErrorMessage, isFetchingBSDOrder} = this.props;
        const {isOpen} = this.props;

        return (
            <ReactstrapModal isOpen={isOpen} toggle={() => this.props.toggleModal()} className="switch-user-modal">
                <ModalHeader toggle={() => this.props.toggleModal()}>Fetch Order from BSD WooCommerce</ModalHeader>
                <ModalBody>
                    <label>
                        Order Number:&nbsp;&nbsp;
                        <input
                            required 
                            name="orderNumber" 
                            onChange={(e) => this.handleInputChange(e)}
                            value={orderNumber}
                        />
                    </label>
                    {extraErrorMessage && <p className='c-red'>{extraErrorMessage}</p>}
                </ModalBody>
                <ModalFooter>
                    {bsdBookingId &&
                        <Button color="success" onClick={() => this.onClickGotoBooking()}>
                            Go To Booking
                        </Button>
                    }
                    <Button color="primary" onClick={() => this.onClickFetch()} disabled={isFetchingBSDOrder}>
                        {isFetchingBSDOrder ? 'Fetching...' : 'Fetch'}
                    </Button>
                    <Button color="secondary" onClick={() => this.props.toggleModal()}>Cancel</Button>
                </ModalFooter>
            </ReactstrapModal>
        );
    }
}


const mapStateToProps = (state) => {
    return {
        isFetchingBSDOrder: state.extra.isFetchingBSDOrder,
        bsdBookingId: state.extra.bsdBookingId,
        extraErrorMessage: state.extra.errorMessage,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        fetchBSDOrder: (bok_1) => dispatch(fetchBSDOrder(bok_1)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(BSDOrderModal);



// WEBPACK FOOTER //
// ./src/components/CommonModals/BSDOrderModal.js